import actionTypes from './types'

/**
 * Race list and chosen race; the choice and the newest race at that time are kept between visits
 * @type {{ list: Array<Object>, selected: number, newest: number }}
 */
const INITIAL_STATE = {
  list: [],
  selected: 0, // chosen race, 0 follows the newest race
  newest: 0 // newest race in the list when the race was chosen
}

/**
 * Store the race list; a race newer than the one known when choosing, or a chosen race that is gone,
 * means following the newest race again
 * @param {Object} state current state
 * @param {Array<Object>} list races, newest first
 * @returns {Object} new state
 */
const setContests = ( state, list ) =>
{
  const races = Array.isArray( list ) ? list : []
  const newest = races.length ? races[ 0 ].id : 0
  const newer = state.selected && state.newest && newest && newest !== state.newest
  const gone = state.selected && races.length && !races.some( race => race.id === state.selected )

  return {
    ...state,
    list: races,
    selected: newer || gone ? 0 : state.selected,
    newest: newest || state.newest
  }
}

/**
 * Reduce the race state
 * @param {Object} state current state
 * @param {Object} action dispatched action
 * @returns {Object} new state
 */
const contestsReducer = ( state = INITIAL_STATE, action ) =>
{
  switch ( action.type )
  {
    case actionTypes.SET_CONTESTS:
      return setContests( state, action.payload )

    case actionTypes.SELECT_CONTEST:
    {
      const { id = 0, newest = 0 } = action.payload || {}
      return { ...state, selected: parseInt( id ) || 0, newest: newest || state.newest }
    }

    default:
      return state
  }
}

export default contestsReducer
